import { lazy } from 'react';

const Splashtech = lazy(() => import(/* webpackChunkName: "splashtech" */ './splashtech-container'));

export default Splashtech;
